import { colors } from '@globals/themes/defaultTheme'
import { spacing } from '@globals/themes/themeConstants'
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import { SxProps } from '@mui/material/styles'
import useMobileRecognitionDrawer, {
  MobileRecognitionDrawerView,
} from '@tenant/recognition/MobileRecognition/useMobileRecognitionDrawer'
import { T } from '@transifex/react'

const buttonStyle: SxProps = {
  minWidth: 0,
  borderRadius: spacing(2),
  p: 0,
  mx: 1,
  mb: 0.5,
  mt: '-23px !important',
}

const iconStyle: SxProps = {
  fontSize: '52px',
  backgroundColor: colors.goldPrimary,
  borderRadius: '50%',
  padding: 1,
  color: `${colors.white} !important`,
}

const RecognizeBottomNavButton = () => {
  const { openDrawer } = useMobileRecognitionDrawer()

  const handleClick = () => {
    openDrawer({ view: MobileRecognitionDrawerView.DRAFT_AND_SCHEDULED })
  }

  return (
    <BottomNavigationAction
      label={<T _str="Recognize" />}
      value="recognize"
      sx={buttonStyle}
      onClick={handleClick}
      icon={<StarBorderRoundedIcon sx={iconStyle} />}
    />
  )
}

export default RecognizeBottomNavButton
